export type FeatureFlagKeys = keyof typeof FEATURE_FLAGS;

export const FEATURE_FLAGS = {
  USE_UNIFIED_LOGIN_UI: 'dashboard-single-login-ui',
} as const;
